import Ladda from 'ladda';
import Dialog from './dialog';
import Edrone from './edrone';

function LocalCart($, $obj) {
  if (this == window) {
    return new LocalCart($, $obj);
  }
  var $cat = $obj.data('product_cat');
  if (typeof $cat == 'undefined') {
    $cat = 'sok';
  }
  this.$ = $;
  this.type = $obj.data('cart_type');
  this.product_category = $cat;
  this.$cart = $obj;
  this.$add = this.$cart.find('.mini_cart__add_to_cart,.add-upsell-to-cart');
  this.ladda = Ladda.create(this.$add[0]);
  this.total_price = 0;
  this.total_qty = 0;
  this.products = {};
  this.persons_qty = 0;
  this.isAbonamentCheckout = window.isAbonamentCheckout;

  if (this.type == 'diet') {
    this.diet_id = $obj.data('diet_id');
  } else if (this.type == 'juice_pack') {
    this.juice_pack_id = $obj.data('product_id');
  }
  this.product_img = $obj.data('product_img');

  //add hooks
  this.addHooks();
  return this;
}

jQuery.extend(LocalCart.prototype, {
  addHooks: function () {
    var self = this;
    var $ = this.$;
    if (this.type == 'page') {
      this.addHooksPage();
    } else {
      this.addHooksDiet();
      this.addHooksPage();
    }
  },
  addHooksDiet: function () {},

  addHooksPage: function () {
    var $ = this.$;
    var self = this;
    var $btn = null;
    if (this.type == 'page') {
      $btn = $('.categories_row').find('.product_less,.product_more');
    } else {
      $btn = this.$cart.find('.product_less,.product_more');
    }
    $btn.click(function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var $parent = $(this).closest('.grater');
      var product_id = $parent.data('product_id');
      var delta = $(this).hasClass('product_more') ? 1 : -1;
      var $qty = $parent.find('.product_qty__inner');
      var qty = 0;
      var multi = [];
      var new_val = -1;
      var product_stock_quantity = $parent.data('stock_quantity');
      //impact on total_qty
      var total_delta = delta;
      if (self.type == 'diet') {
        //get multipliers
        //can be more than 2
        self.$cart.find('.multiplier').each(function () {
          var val = parseInt($(this).text());

          if (this == $qty[0]) {
            //to jest to pole, ktore zainicjowalo eventy
            val += delta;
            new_val = Math.min(7, Math.max(val, 1));
            val = new_val;
          }
          multi.push(val);
        });
        qty = multi[0];
        self.total_qty = qty;
        total_delta = 0;
        self.persons_qty = multi[1];
      } else {
        if (product_stock_quantity || product_stock_quantity === 0) {
          if ($qty.text() < product_stock_quantity) {
            qty = parseInt($parent.find('.multiplier').text()) + delta;
          } else {
            qty = $qty.text();
            if (delta > 0) {
              total_delta -= 1;
            } else {
              qty--;
            }
          }
        } else {
          qty = parseInt($parent.find('.multiplier').text()) + delta;
        }
      }
      var created = false;
      self.$cart.removeClass('is-transparent');
      if (self.products[product_id] == void 0) {
        created = true;
        self.createProductRecord(product_id);
      }
      let oldVal = self.products[product_id].qty;
      self.products[product_id].qty = qty; //delta;
      if (qty <= 0) {
        if (qty < 0) {
          total_delta = 0;
        }
        self.removeProduct(product_id);
      } else {
        if (self.type == 'page') {
          if (qty > 99) {
            self.products[product_id].qty = qty = 99;
            total_delta = 0;
          }
        }
        if (total_delta > 0 && self.isAbonamentCheckout) {
          if (self.total_qty >= 6) {
            self.products[product_id].qty = qty = oldVal;
            total_delta = 0;
            if (qty == 0) {
              self.removeProduct(product_id);
            }
          }
        }
        //update mini cart
        if (created) {
          self.rebuildList();
        } else {
          var $mini_qty = self.$cart.find('.product_qty_' + product_id);
          var $mini_price = self.$cart.find('.product_price_' + product_id);
          $mini_qty.text(qty);
          $mini_price.html(self.formatPrice(self.products[product_id].price));
        }
        if (self.type == 'page') {
          $qty.text(qty);
        }
      }
      if (self.type == 'diet') {
        $qty.text(new_val);
        self.triggerCssAnimationOnElement($qty, 'changed-val');
      }
      self.total_qty += total_delta;
      self.validateMinQty();
      self.updateSum();
      self.setQtyInputVal(product_id);
      if(self.checkQuantity(qty, product_stock_quantity, $(this).parent().children('.product_more'), self)) {
        self.triggerCssAnimationOnElement($qty, 'changed-val');
      }
    });
    self.$cart.on('click', '.remove', function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      var pid = $(this).data('product_id');
      self.removeProduct(pid);
    });
    self.$add.click(function (ev) {
      let $btn = $(ev.currentTarget);
      if ($btn.hasClass('is-disabled')) {
        ev.stopPropagation();
        ev.preventDefault();
        return;
      }
      ev.stopPropagation();
      ev.preventDefault();
      let that = self;
      $btn.addClass('is-disabled');
      let p = self.products;
      let ladda = Ladda.create(ev.currentTarget);
      if (Object.keys(p).length === 0) {
        if (self.type === 'diet') {
          p = self.diet_id;
        } else if (self.type === 'juice_pack') {
          p = self.juice_pack_id;
        } else if (self.type === 'upsell') {
          p = ev.currentTarget.getAttribute('data-product-id');
        } else {
          //nie dodalismy produktow
          return;
        }
      }
      let data = {
        action: 'custom_add_to_cart',
        products: p,
      };

      if (self.type == 'diet') {
        //we have to get
        let pq = self.$cart.find('.persons_qty .product_qty__inner').text();
        data['persons_qty'] = pq;
        if (typeof p == 'object') {
          p[self.diet_id].qty = p[self.diet_id].qty;
        }
      }
      try {
        /**
         * TRACKING
         */
        if (window.dataLayer) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'PLN',
              value: self.getTotalPrice(),
              items: self.getGoogleProducts(),
            },
          });
        }
        if (window.userengage) {
          for (let [key, val] of Object.entries(self.getUserEngageProducts())) {
            console.log('user engage');
            console.log(val);
            userengage('event.AddToCart', val);
          }
        }
      } catch (e) {
        console.error(e);
      }
      Edrone.push(function (_edrone) {
        _edrone.action_type = 'add_to_cart';

        let data = self.products;

        for (var key in data) {
          _edrone.product_titles = data[key].title;
          _edrone.product_counts = data[key].qty;
          _edrone.product_category_names =
            data[key].categoryName && data[key].categoryName.length > 0
              ? data[key].categoryName
              : data[key].title;

          if (self.product_category == 'dieta' && typeof pq != 'undefined') {
            var qty = self.getTotalQty();
            _edrone.product_titles = `${data[key].title} na ${qty} ${
              qty > 1 ? 'dni' : 'dzień'
            }`;
            _edrone.product_counts = pq;
          }

          _edrone.init();
        }
      });
      if (self.isAbonamentCheckout) {
        data['abonament'] = window.abonamentQty;
      }
      self.$.post(
        backend.wc_ajax.replace('%%endpoint%%', 'custom_add_to_cart'),
        data,
        function (response) {
          self.replaceFragments(response.fragments);
          if (self.isAbonamentCheckout) {
            if (!response.location) {
              alert('Wystąpił błąd!');
              return;
            }
            window.location.href = response.location;
            return;
          }

          $btn.removeClass('is-disabled');
          ladda.stop();
          if (typeof response.fragments.missing_juices != 'undefined') {
            window.missing_juices = response.fragments.missing_juices;
            for (let i = 0; i < window.carts.length; ++i) {
              window.carts[i].validateMinQty();
            }
            delete response.fragments.missing_juices;
          }

          self.total_qty = 0;
          for (let i in self.products) {
            if (!self.products.hasOwnProperty(i)) {
              continue;
            }
            if (self.type == 'diet') {
              self.products[i].qty = 1;
            } else {
              self.removeProduct(i);
            }
          }
          if (self.type == 'diet') {
            self.persons_qty = 1;
            self.$cart.find('.product_qty .product_qty__inner').text('1');
            self.updateSum();
          } else {
            self.validateMinQty();
            self.updateSum();
          }
          if (self.type == 'upsell') {
            window.location.reload();
            return;
          }
          /**
           * Open confirmation dialog
           */
          let dlg = new Dialog(
            `<h3>Dziękujemy!</h3>` +
              `<div class="desc">${
                self.product_category === 'products' ? 'Produkty' : 'Soki'
              } zostały dodane do koszyka</div>` +
              `<div class="buttons">` +
              `<a class="ghost_button bg_red close_dialog" href="#">Kontynuuj zakupy</a>` +
              `<a class="ghost_button bg_red" href="${window.backend.cart}">Przejdź do koszyka</a>` +
              `</div>`
          );
          dlg.open();
        }
      );
      ladda.start();
    });
  },
  createProductRecord: function (product_id) {
    var $parent = jQuery(".grater[data-product_id='" + product_id + "']");
    if (this.type == 'juice_pack') {
      $parent = jQuery(".local_cart[data-product_id='" + product_id + "']");
    }
    this.hasProducts = true;
    this.products[product_id] = {
      id: product_id,
      title: $parent.data('product_title'),
      categoryName: $parent.data('cat_name'),
      price: $parent.data('product_price'),
      dynamic_pricing: $parent.data('dynamic_pricing'),
      qty: 0,
      omnibus: $parent.data('omnibus')
    };
  },
  formatPrice: function (price) {
    return (
      (parseFloat(price).toFixed(2) + '').replace('.', ',') +
      ' ' +
      backend.currency
    );
  },

  validateMinQty: function () {
    var minQty = window.missing_juices;
    
    if (this.isAbonamentCheckout) {
      minQty = 6;
    } else if (minQty == 0) {
      minQty = 1;
    }
    var q = this.total_qty;
    if (this.type == 'juice_pack' || this.type == 'diet') {
      return;
    }
    var more = minQty - q;
    if (more <= 0) {
      this.$cart.find('.not_enough_items').hide();
      this.$cart.find('.mini_cart__add_to_cart').removeClass('is-disabled');
    } else {
      if (minQty > 1) {
        this.$cart.find('.not_enough_items').show();
      } else {
        this.$cart.find('.not_enough_items').hide();
      }
      this.$cart
        .find('.qty')
        .text(
          more +
            ' ' +
            (this.product_category === 'products'
              ? this.produktyCases(more)
              : this.sokiCases(more))
        );
      this.$cart.find('.mini_cart__add_to_cart').addClass('is-disabled');
    }
    if (q == 0) {
      this.$cart.find('.mini_cart__list').addClass('is-empty');
    } else {
      this.$cart.find('.mini_cart__list').removeClass('is-empty');
    }
  },

  replaceFragments: function (fragments) {
    // Replace fragments
    var self = this;
    if (fragments) {
      this.$.each(fragments, function (key, value) {
        self.$(key).replaceWith(value);
      });
    }
  },

  removeProduct: function (pid) {
    this.products[pid].qty = 0;
    this.setQtyInputVal(pid);
    delete this.products[pid]; //.qty = 0;
    this.$(".grater[data-product_id='" + pid + "'] .product_qty__inner").html(
      0
    );
    this.rebuildList();
  },

  sokiCases: function (qty) {
    var $number = '';
    if (qty == 1) {
      $number = 'sok';
    } else if (qty >= 5) {
      $number = 'soków';
    } else {
      $number = 'soki';
    }
    return $number;
  },

  produktyCases: function (qty) {
    var $number = '';
    if (qty == 1) {
      $number = 'produkt';
    } else if (qty >= 5) {
      $number = 'produktów';
    } else {
      $number = 'produkty';
    }
    return $number;
  },

  setQtyInputVal: function (pid) {
    //this.$("input[name='product_qty["+pid+"]']").val(this.products[pid].qty);
  },

  rebuildList: function () {
    if (this.type != 'page') {
      return;
    }
    this.$cart.find('.mini_cart__list').html(this.createCartRecords());
  },

  triggerCssAnimationOnElement: function (t, e) {
    return t.removeClass(e), t.hide().show(0), t.addClass(e);
  },

  createCartRecords: function () {
    if (this.type != 'page') {
      return;
    }
    let html = '';
    Object.keys(this.products).forEach((id) => {
      const i = this.products[id];
      html += `
<li class="mini_cart__record" data-product_id="${i.id}">
    <input type="hidden" name="product_qty[${i.id}]" value="${i.qty}">
    <div>
      <div>
        <a class="title open_product_popup" data-product_id="${i.id}" href="#">
            ${i.title}
        </a>
        <div class="break"></div>
        <div class="right">
            <span class="quantity_wrap"><span class="quantity product_qty_${
              i.id
            }">${i.qty}</span>x</span>
            <span class="price product_price_i.id'">${this.formatPrice(
              this.calculatePrice(i, 1)
            )}</span>
        </div>
      </div>
      ${i.omnibus}
    </div>
</li>`;
    });
    return html;
  },

  calculatePrice: function (item, force_qty) {
    return this.dynamicPrice(item, force_qty);
  },

  dynamicPrice: function (item, force_qty) {
    let qty = item.qty;

    if (typeof force_qty != 'undefined') {
      qty = force_qty;
    }

    var val = item.price * qty;
    if (
      item['dynamic_pricing'] == void 0 ||
      item['dynamic_pricing'][qty] == void 0
    ) {
      //normal pricing
    } else {
      val = item['dynamic_pricing'][qty];
    }
    if (this.type == 'diet') {
      val = this.persons_qty * val;
    }
    return parseFloat(val);
  },
  getProductsForAnalytics: function () {
    if (window.abonamentQty) {
      const p = window.abonamentProduct;
      let data = {};
      data[p.id] = {
        id: p.id,
        title: p.post.post_title,
        categoryName: 'Abonament',
        price: p.price,
        qty: 1,
        juices: {},
      };
      for (let [key, val] of Object.entries(this.products)) {
        data[p.id].juices[key] = {
          id: key,
          title: val.title,
        };
      }
      return data;
    }
    if (!this.hasProducts) {
      if (this.type == 'diet') {
        this.createProductRecord(this.diet_id);
        this.products[this.diet_id].qty = 1;
        this.persons_qty = 1;
      } else if (this.type == 'juice_pack') {
        this.createProductRecord(this.juice_pack_id);
        this.products[this.juice_pack_id].qty = 1;
      }
    }
    return this.products;
  },
  getFacebookNames: function () {
    let ret = [];
    for (let [id, product] of Object.entries(this.getProductsForAnalytics())) {
      ret.push(product.title);
    }
    return ret.join(', ');
  },
  getFacebookIds: function () {
    let ret = [];
    for (let [id, product] of Object.entries(this.getProductsForAnalytics())) {
      ret.push(parseInt(id));
    }
    return ret;
  },
  getFacebookProducts: function () {
    var ret = [];
    for (let [id, product] of Object.entries(this.getProductsForAnalytics())) {
      var data = {
        id: id,
        title: product.title,
        qty: product.qty,
      };
      if (this.type == 'diet') {
        data.persons_qty = this.persons_qty;
      }
      ret.push(data);
    }

    return ret;
  },
  getGoogleProducts: function () {
    let ret = [];
    for (let [id, product] of Object.entries(this.getProductsForAnalytics())) {
      ret.push({
        item_id: id,
        item_name:
          product.title +
          (this.type == 'diet' ? '(dni: ' + product.qty + ')' : ''),
        price: product.price,
        currency: 'PLN',
        quantity: this.type == 'diet' ? this.persons_qty : product.qty,
      });
    }

    return ret;
  },
  getUserEngageProducts: function () {
    let ret = [];
    for (let [id, product] of Object.entries(this.getProductsForAnalytics())) {
      let data = {
        pid: id,
        title: product.title,
        quantity: this.type == 'diet' ? this.persons_qty : product.qty,
        price: product.price,
        type: this.type,
      };
      if (this.type == 'diet') {
        data.days = product.qty;
      }
      if (product.juices) {
        data.type = 'abonament';
        data.juices = JSON.stringify(product.juices);
      }
      if (!data.days) {
        data.days = 1;
      }
      data.sum = data.days * data.quantity * data.price;
      ret.push(data);
    }
    return ret;
  },
  getTotalQty: function () {
    if (!this.hasProducts) {
      if (this.type == 'diet' || this.type == 'juice_pack') {
        return 1;
      }
      return 0;
    }
    var val = 0;
    for (var id in this.products) {
      if (this.products.hasOwnProperty(id) == false) {
        continue;
      }
      val += this.products[id].qty;
    }
    return val;
  },
  getTotalPrice: function () {
    var val = 0;

    if (!this.hasProducts) {
      if (this.type == 'diet') {
        this.createProductRecord(this.diet_id);
        this.products[this.diet_id].qty = 1;
        this.persons_qty = 1;
      } else if (this.type == 'juice_pack') {
        this.createProductRecord(this.juice_pack_id);
        this.products[this.juice_pack_id].qty = 1;
      }
    }
    for (var id in this.products) {
      val += this.calculatePrice(this.products[id]);
    }

    return val;
  },
  checkQuantity: (qty, max_qty, el, context) => {
    if(!max_qty) {
      return true;
    }

    if(qty < max_qty) {
      $(el).removeClass('-max');
      return true;
    } else {
      $(el).addClass('-max');
      context.triggerCssAnimationOnElement($(el).parent().find('.product_qty__inner'), 'changed-val');
    }
  },
  updateSum: function () {
    var val = this.getTotalPrice();
    if (this.type == 'diet' && Object.keys(this.products).length > 0) {
      var p = this.products[Object.keys(this.products)[0]];
      var dp = this.dynamicPrice(p) / this.persons_qty;
      var singlep = this.dynamicPrice(p, 1);

      this.$cart
        .closest('.bundle')
        .find('.bundle__price .amount')
        .html(
          this.formatPrice(dp / p.qty) +
            (this.persons_qty > 1 ? ' * ' + this.persons_qty : '')
        );
      var savings = singlep * p.qty - dp * this.persons_qty;
      if (savings > 0) {
        this.$cart
          .closest('.bundle')
          .find('.bundle__price .savings')
          .html('Oszczędzasz ' + this.formatPrice(singlep * p.qty - dp));
      } else {
        this.$cart.closest('.bundle').find('.bundle__price .savings').text('');
      }
    }
    this.$cart.find('.mini_cart__total_val').html(this.formatPrice(val));
  },
});
(function ($) {
  //add hooks
  window.carts = [];
  $('.local_cart').each(function () {
    var c = new LocalCart($, $(this));
    window.carts.push(c);
  });
})(jQuery);
export default {
  create(el) {
    var c = new LocalCart($, $(el));
    window.carts.push(c);
  },
};



// WEBPACK FOOTER //
// ./assets/js/local-cart.js